import React from 'react'

export const TomSvg = () => {
    return (
<svg viewBox="0 0 1024 1024" width="1.5em" height="1.5em" fill="currentColor"  >
<g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">
<path d="M5255 9756 c-49 -21 -69 -50 -61 -88 5 -24 35 -60 114 -138 63 -61
124 -131 146 -167 36 -60 83 -178 68 -171 -4 2 -52 29 -107 60 -182 103 -375
170 -585 203 -146 23 -430 31 -560 16 -528 -61 -1015 -306 -1341 -676 -44 -49
-134 -166 -201 -260 -193 -268 -323 -384 -493 -438 -56 -18 -94 -22 -190 -22
-134 0 -175 10 -307 76 -92 46 -125 49 -159 13 -50 -53 -31 -267 40 -433 72
-170 204 -315 373 -410 l56 -32 -43 -92 c-81 -171 -112 -299 -121 -492 -16
-318 70 -675 232 -967 24 -44 44 -81 44 -83 0 -1 -19 -8 -43 -15 -193 -57
-351 -235 -423 -475 -32 -109 -44 -315 -25 -444 57 -386 336 -790 671 -969
152 -82 354 -129 512 -121 l48 3 44 -87 c191 -374 548 -740 933 -958 l43 -24
0 -192 c0 -106 -2 -193 -5 -193 -19 0 -942 -272 -1085 -319 -307 -102 -511
-215 -676 -373 -189 -182 -305 -388 -384 -683 -50 -184 -39 -259 42 -301 28
-15 335 -16 3310 -16 l3279 1 33 21 c77 47 83 135 22 347 -76 264 -162 417
-326 584 -191 194 -365 294 -726 419 -91 31 -764 231 -1026 305 l-58 16 0 194
0 193 73 43 c410 242 679 517 897 917 l55 99 123 7 c183 10 329 53 474 137
301 176 547 532 622 901 18 89 21 300 5 397 -13 81 -65 221 -110 297 -86 146
-234 251 -389 276 -41 6 -76 13 -78 14 -2 1 9 43 23 94 63 225 99 451 100 628
0 123 2 141 15 135 29 -14 89 -7 110 12 41 37 61 136 62 305 0 171 -11 241
-62 381 -95 265 -300 484 -557 600 -37 17 -69 32 -71 34 -2 2 4 25 13 51 34
100 49 208 49 349 1 146 -7 196 -50 330 -75 233 -240 475 -412 606 -84 63
-131 79 -168 54 -27 -17 -27 -17 -18 -99 15 -141 11 -323 -9 -409 -10 -43 -21
-76 -24 -73 -3 3 -20 50 -38 103 -173 534 -645 895 -1301 997 -126 20 -357 21
-399 2z m645 -348 c306 -97 569 -299 705 -542 112 -201 149 -447 99 -664 -7
-35 -14 -78 -14 -97 0 -67 82 -124 157 -109 43 8 132 81 198 161 100 121 170
256 219 424 l24 83 26 -52 c71 -140 104 -311 86 -453 -28 -233 -135 -414 -330
-559 -243 -179 -563 -272 -995 -287 -424 -14 -758 59 -1136 248 -280 140 -438
191 -643 211 -331 31 -626 -57 -913 -273 -374 -283 -619 -740 -708 -1326 -20
-127 -35 -455 -28 -597 l5 -111 -66 65 c-86 84 -149 179 -241 365 -184 373
-234 705 -154 1019 27 104 71 201 148 319 50 76 61 102 61 135 0 59 -43 99
-148 135 -136 47 -269 147 -344 258 -35 52 -35 61 0 52 15 -5 95 -8 177 -7
171 0 220 11 351 76 180 89 321 222 499 473 247 347 491 553 825 693 359 150
737 188 1115 110 299 -61 563 -218 694 -411 24 -35 57 -72 72 -81 63 -37 151
-8 193 64 18 29 22 56 24 160 5 183 -35 357 -119 522 l-20 40 43 -7 c24 -4 86
-21 138 -37z m1667 -1848 c271 -127 424 -338 457 -632 l6 -57 -66 35 c-73 38
-135 44 -184 19 -74 -38 -78 -95 -15 -220 54 -108 75 -206 75 -342 -1 -276
-115 -706 -223 -838 l-25 -29 -5 284 c-6 320 -21 448 -81 681 -77 301 -202
563 -361 760 l-53 66 36 19 c71 38 188 132 262 212 41 44 79 81 84 81 4 1 46
-17 93 -39z m-3186 -86 c117 -22 187 -48 414 -154 389 -182 490 -217 755 -261
183 -31 625 -34 820 -6 146 21 310 57 394 86 l60 21 24 -22 c48 -44 143 -171
197 -263 257 -436 323 -1008 240 -2075 -29 -373 -93 -773 -151 -945 -156 -466
-589 -899 -1170 -1170 -306 -143 -671 -234 -889 -222 -579 32 -1332 436 -1700
911 -239 308 -323 550 -394 1126 -57 467 -79 1170 -46 1500 47 484 195 852
451 1128 272 294 625 416 995 346z m-2026 -2117 c93 -44 189 -175 276 -376 38
-89 51 -160 84 -471 l4 -45 -40 45 c-72 79 -119 201 -134 347 -9 82 -26 118
-68 143 -69 43 -165 10 -199 -67 -25 -57 -19 -147 19 -268 67 -214 198 -373
381 -462 l79 -38 23 -110 c13 -60 25 -119 27 -131 4 -20 2 -20 -78 -12 -91 9
-156 27 -234 66 -235 116 -480 433 -545 703 -41 172 -20 404 47 518 38 65 107
136 156 160 58 29 137 28 202 -2z m5730 -1 c28 -13 72 -46 98 -75 89 -95 127
-213 127 -391 0 -219 -66 -398 -228 -618 -160 -219 -361 -344 -576 -359 l-79
-6 6 24 c4 13 17 72 28 130 l22 107 41 13 c68 23 177 101 249 179 135 146 237
432 198 553 -26 78 -104 121 -180 98 -61 -18 -81 -48 -92 -138 -14 -114 -35
-189 -74 -268 -29 -58 -85 -135 -98 -135 -6 0 32 354 43 398 26 107 156 351
223 420 89 92 191 116 292 68z m-3772 -2985 c281 -127 656 -197 925 -172 271
24 504 88 797 217 7 3 10 -70 9 -208 0 -202 -2 -215 -23 -257 -67 -129 -245
-255 -441 -314 -166 -50 -251 -62 -460 -62 -210 0 -322 16 -479 70 -181 61
-345 183 -409 303 l-32 60 0 206 0 206 23 -9 c12 -5 53 -23 90 -40z m2085
-526 c7 -5 -85 -156 -129 -210 -202 -254 -533 -421 -932 -470 -637 -79 -1254
185 -1481 633 l-26 52 32 0 c18 0 42 3 53 6 17 4 31 -10 78 -79 130 -191 320
-326 581 -411 403 -132 942 -99 1298 80 168 84 323 222 401 356 l38 66 42 -11
c23 -5 43 -11 45 -12z m-2820 -125 c79 -169 261 -386 426 -508 375 -275 896
-392 1421 -316 55 7 111 16 125 20 94 21 125 29 210 56 323 103 615 308 784
550 37 52 123 215 138 259 4 13 344 -84 647 -183 413 -136 629 -297 769 -573
20 -41 74 -189 86 -237 l6 -28 -3070 0 c-1688 0 -3070 2 -3070 4 0 3 12 42 26
88 32 102 101 243 159 323 88 124 239 243 404 321 87 41 374 138 631 214 96
28 193 57 215 65 22 7 45 14 50 14 6 0 25 -31 43 -69z"/>
<path d="M3995 6529 c-116 -13 -287 -51 -364 -82 -95 -39 -210 -115 -288 -193
-118 -118 -143 -196 -80 -259 53 -53 96 -54 214 -7 54 22 148 52 208 68 101
26 125 28 295 29 134 0 207 -5 265 -17 44 -9 97 -19 118 -23 80 -13 196 45
233 117 23 45 20 150 -7 204 -39 83 -110 124 -254 148 -127 21 -235 26 -340
15z"/>
<path d="M5985 6524 c-120 -16 -190 -32 -230 -51 -133 -66 -175 -244 -83 -349
66 -75 143 -92 285 -63 58 11 161 22 253 25 225 9 350 -15 579 -111 100 -42
185 -18 211 60 24 72 -37 174 -168 279 -166 134 -317 190 -581 216 -124 12
-138 12 -266 -6z"/>
<path d="M3785 5804 c-181 -45 -336 -175 -429 -362 -85 -168 -96 -468 -18
-473 68 -5 83 18 98 154 15 131 37 194 100 289 103 154 258 229 444 214 100
-7 164 -28 238 -76 170 -109 244 -246 265 -488 11 -123 13 -136 35 -150 21
-14 25 -13 50 5 36 27 50 80 51 188 1 135 -20 231 -73 340 -83 170 -225 294
-403 351 -70 23 -282 28 -358 8z"/>
<path d="M6133 5805 c-142 -32 -301 -144 -386 -273 -88 -133 -120 -242 -119
-407 0 -126 13 -188 45 -210 26 -18 38 -19 61 -2 16 11 20 35 27 143 12 193
57 304 168 415 255 255 656 195 813 -121 38 -76 53 -139 64 -264 5 -59 10 -74
34 -98 35 -34 54 -35 85 -4 45 45 43 224 -5 380 -43 137 -163 291 -284 364
-101 61 -186 85 -321 88 -78 2 -142 -1 -182 -11z"/>
<path d="M3900 5470 c-95 -24 -173 -92 -220 -192 -87 -184 -9 -414 167 -495
48 -22 65 -25 137 -21 66 3 91 10 135 33 68 37 124 101 152 174 32 81 32 223
0 304 -28 71 -102 149 -168 178 -54 24 -150 33 -203 19z"/>
<path d="M6190 5467 c-61 -17 -110 -48 -155 -98 -131 -145 -113 -421 36 -538
73 -58 124 -74 216 -69 91 5 143 28 203 88 174 174 127 499 -87 597 -65 30
-151 38 -213 20z"/>
<path d="M5031 4629 c-120 -23 -262 -127 -307 -224 -28 -58 -30 -85 -9 -125
24 -46 62 -70 112 -70 53 0 82 18 118 71 38 58 118 94 192 86 66 -7 137 -46
158 -88 34 -66 135 -91 190 -47 15 12 34 37 42 55 12 30 12 41 -2 89 -12 43
-29 68 -79 119 -111 114 -266 164 -415 134z"/>
<path d="M4105 3995 c-98 -35 -109 -142 -22 -222 97 -89 319 -219 464 -273
360 -131 818 -127 1166 11 183 72 434 231 477 302 44 72 11 165 -66 186 -48
13 -78 2 -163 -62 -261 -196 -605 -293 -951 -267 -312 24 -527 108 -790 309
-36 27 -69 32 -115 16z"/>
</g>
</svg>
)
}

export default TomSvg
